import { type InputHTMLAttributes, forwardRef } from "react";
import clsx from "clsx";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1">
        {label && (
          <label className="text-sm font-body font-bold text-grey">
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={clsx(
            "px-3 py-2 rounded-lg border bg-white font-body text-sm",
            "focus:outline-none focus:ring-2 focus:ring-orange/50 focus:border-orange",
            "placeholder:text-beige",
            error ? "border-red-500" : "border-beige/40",
            className,
          )}
          {...props}
        />
        {error && <p className="text-xs text-red-600 font-body">{error}</p>}
      </div>
    );
  },
);

Input.displayName = "Input";
